module.exports = __webpack_public_path__ + "static/media/programme_logo_en.a4479138.png";